<template>
    <div class="card">
        <div class="card-header py-1">
            <h5><span>{{title}}</span>
            <router-link v-if="isView" class="float-right float-end btn btn-primary" :to="{path: url}" tag="a">{{lang('view')}}</router-link>
            <router-link v-else class="float-right float-end btn btn-primary" :to="{path: url}" tag="a">{{lang('edit')}}</router-link>
            </h5>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-12">
                    <np-entry
                            :label="lang('status')"
                            mode="inline"
                            :model-value="status">
                    </np-entry>
                    <np-entry
                            :label="lang('percentage_completed')"
                            mode="inline"
                            value="100%">
                    </np-entry>
                    <np-entry
                            :label="lang('estimated_time_to_complete')"
                            mode="inline"
                            value="15 mins">
                    </np-entry>
                </div>
                <div class="col-lg-6 col-md-6 col-12">
                    <np-entry
                            :label="lang('reference')"
                            mode="inline"
                            :model-value="reference">
                    </np-entry>
                    <np-entry
                            :label="lang('date_added')"
                            mode="inline"
                            :model-value="entity.date_added">
                    </np-entry>
                    <np-entry
                            :label="lang('date_updated')"
                            mode="inline"
                            :model-value="entity.updated_added">
                    </np-entry>
                </div>
            </div>


        </div>
        <div class="">
        </div>
    </div>
</template>

<script>
    export default {
        name: "dashboard-card",
        props: {
            entity: {
                type: Object,
                default () {
                    return {}
                }
            },
            status: '',
            url: {
                type: String,
                default: ''
            },
            title: '',
            reference: '',
            isView: Boolean,
        },
        data (){
            return {

            }
        },
        methods: {

        }

    }
</script>

<style scoped>

</style>
